import React from 'react'
import { Component } from 'reflux'
import { toast } from 'react-toastify'
import { ExpectedDeliveryStatusActions, ExpectedDeliveryStatusStore, STATUS } from 'Stores/expectedDeliveryStatusStore'
import ExpectedDeliveryStatusForm from 'Modules/ExpectedDeliveryStatus/expectedDeliveryStatusForm'
import DynamicTable from 'Components/dynamicTable'
import CollapsibleCard from 'Components/collapsibleCard'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, ButtonGroup, UncontrolledTooltip as Tooltip } from 'reactstrap'
import moment from 'moment'
import 'moment/locale/da'
import { Link } from 'react-router-dom'
import ExpectedDeliveryStatusLinkModal from './expectedDeliveryStatusLinkModal'

export default class ExpectedDeliveryStatusEdit extends Component {
  constructor(props) {
    super(props)
    this.stores = [ExpectedDeliveryStatusStore]
    this.storeKeys = ['status', 'productLinks', 'supplierLinks', 'variationLinks', 'showAddLinkModalType']
  }

  componentDidMount() {
    ExpectedDeliveryStatusActions.getExpectedDeliveryStatusDetails(this.props.match.params.ExpectedDeliveryStatusID)
  }

  componentDidUpdate() {
    if (this.state.status === STATUS.UPDATE_SUCCESS) {
      toast.success('ExpectedDeliveryStatus Updated', {
        autoClose: 3000,
        onClose: () => {
          ExpectedDeliveryStatusActions.clearFormToast()
        }
      })
      ExpectedDeliveryStatusActions.clearFormToast(STATUS.REDIRECT)
    }
    if (this.state.status === STATUS.UPDATE_ERROR) {
      toast.error('ExpectedDeliveryStatus Update Failed', {
        autoClose: 3000,
        onClose: () => {
          ExpectedDeliveryStatusActions.clearFormToast()
        }
      })
      ExpectedDeliveryStatusActions.clearFormToast(STATUS.REDIRECT)
    }
    if (this.state.status === STATUS.DELETE_LINK_ERROR) {
      toast.error('Failed to Delete Link', {
        autoClose: 3000,
        onClose: () => {
          ExpectedDeliveryStatusActions.clearFormToast()
        }
      })
      ExpectedDeliveryStatusActions.clearFormToast(STATUS.REDIRECT)
    }
  }

  render() {
    return (
      <React.Fragment>
        <ExpectedDeliveryStatusForm match={this.props.match} />

        <CollapsibleCard startOpen header={<strong>Leverandører</strong>}>
          <Button
            style={{ marginBottom: 16, marginLeft: 'auto', display: 'block' }}
            onClick={() => {
              ExpectedDeliveryStatusActions.setAddLinkModalType('Supplier')
            }}
          >
            Tilføj leverandør
          </Button>
          <DynamicTable
            responsive
            size='sm'
            options={{
              startSort: {
                dir: 'DESC',
                column: 'SupplierID'
              },
              fieldFunctions: {
                supplierName: e => {
                  return <Link to={`/suppliers/${e.SupplierID}`}>{e.supplierName}</Link>
                },
                timeStart: e => {
                  if (e.timeStart) {
                    return moment(e.timeStart).format('YYYY-MM-DD')
                  }
                },
                timeEnd: e => {
                  if (e.timeEnd) {
                    return moment(e.timeEnd).format('YYYY-MM-DD')
                  }
                }
              },
              fieldStringFunctions: {
                poolOrder: e => {
                  return e.poolOrder
                },
                timeStart: e => {
                  return moment(e.timeStart).format('x')
                },
                timeEnd: e => {
                  return moment(e.timeEnd).format('x')
                }
              },
              addField: e => {
                return (
                  <td style={{ display: 'flex', justifyContent: 'end' }}>
                    <ButtonGroup>
                      <Tooltip target={'delete' + e.SupplierID}>Slet</Tooltip>
                      <Button
                        id={'delete' + e.SupplierID}
                        onClick={() => {
                          if (confirm('Vil du slette dette link?')) {
                            ExpectedDeliveryStatusActions.deleteSupplierLink(e.SupplierExpectedDeliveryStatusID)
                          }
                        }}
                        color='danger'
                      >
                        <FontAwesomeIcon icon='trash' />
                      </Button>
                    </ButtonGroup>
                  </td>
                )
              }
            }}
            headers={{
              SupplierID: 'Leverandør ID',
              supplierName: 'Navn',
              timeStart: 'Start',
              timeEnd: 'End'
            }}
            data={this.state.supplierLinks}
          />
        </CollapsibleCard>

        <CollapsibleCard startOpen header={<strong>Produkter</strong>}>
          <Button
            style={{ marginBottom: 16, marginLeft: 'auto', display: 'block' }}
            onClick={() => {
              ExpectedDeliveryStatusActions.setAddLinkModalType('Product')
            }}
          >
            Tilføj produkt
          </Button>
          <DynamicTable
            responsive
            size='sm'
            options={{
              startSort: {
                dir: 'DESC',
                column: 'ProductID'
              },
              fieldFunctions: {
                productName: e => {
                  return <Link to={`/products/${e.ProductID}`}>{e.productName}</Link>
                },
                timeStart: e => {
                  if (e.timeStart) {
                    return moment(e.timeStart).format('YYYY-MM-DD')
                  }
                },
                timeEnd: e => {
                  if (e.timeEnd) {
                    return moment(e.timeEnd).format('YYYY-MM-DD')
                  }
                }
              },
              fieldStringFunctions: {
                poolOrder: e => {
                  return e.poolOrder
                },
                timeStart: e => {
                  return moment(e.timeStart).format('x')
                },
                timeEnd: e => {
                  return moment(e.timeEnd).format('x')
                }
              },
              addField: e => {
                return (
                  <td style={{ display: 'flex', justifyContent: 'end' }}>
                    <ButtonGroup>
                      <Tooltip target={'delete' + e.ProductID}>Slet</Tooltip>
                      <Button
                        id={'delete' + e.ProductID}
                        color='danger'
                        onClick={() => {
                          if (confirm('Vil du slette dette link?')) {
                            ExpectedDeliveryStatusActions.deleteProductLink(e.ProductExpectedDeliveryStatusID)
                          }
                        }}
                      >
                        <FontAwesomeIcon icon='trash' />
                      </Button>
                    </ButtonGroup>
                  </td>
                )
              }
            }}
            headers={{
              ProductID: 'Produkt ID',
              productName: 'Titel',
              timeStart: 'Start',
              timeEnd: 'End'
            }}
            data={this.state.productLinks}
          />
        </CollapsibleCard>

        <CollapsibleCard startOpen header={<strong>Variationer</strong>}>
          <Button
            style={{ marginBottom: 16, marginLeft: 'auto', display: 'block' }}
            onClick={() => {
              ExpectedDeliveryStatusActions.setAddLinkModalType('Variation')
            }}
          >
            Tilføj variation
          </Button>
          <DynamicTable
            responsive
            size='sm'
            options={{
              startSort: {
                dir: 'DESC',
                column: 'VariationID'
              },
              fieldFunctions: {
                variationName: e => {
                  return <Link to={`/products/${e.ProductID}`}>{e.variationName}</Link>
                },
                timeStart: e => {
                  if (e.timeStart) {
                    return moment(e.timeStart).format('YYYY-MM-DD')
                  }
                },
                timeEnd: e => {
                  if (e.timeEnd) {
                    return moment(e.timeEnd).format('YYYY-MM-DD')
                  }
                }
              },
              fieldStringFunctions: {
                timeStart: e => {
                  return moment(e.timeStart).format('x')
                },
                timeEnd: e => {
                  return moment(e.timeEnd).format('x')
                }
              },
              addField: e => {
                return (
                  <td style={{ display: 'flex', justifyContent: 'end' }}>
                    <ButtonGroup>
                      <Tooltip target={'delete' + e.VariationID}>Slet</Tooltip>
                      <Button
                        id={'delete' + e.VariationID}
                        color='danger'
                        onClick={() => {
                          if (confirm('Vil du slette dette link?')) {
                            ExpectedDeliveryStatusActions.deleteVariationLink(e.VariationExpectedDeliveryStatusID)
                          }
                        }}
                      >
                        <FontAwesomeIcon icon='trash' />
                      </Button>
                    </ButtonGroup>
                  </td>
                )
              }
            }}
            headers={{
              VariationID: 'Variation ID',
              variationName: 'Titel',
              timeStart: 'Start',
              timeEnd: 'End'
            }}
            data={this.state.variationLinks}
          />
        </CollapsibleCard>

        <ExpectedDeliveryStatusLinkModal
          ExpectedDeliveryStatusID={this.props.match.params.ExpectedDeliveryStatusID}
          isOpen={!!this.state.showAddLinkModalType}
          toggle={() => ExpectedDeliveryStatusActions.setAddLinkModalType(null)}
          linkType={this.state.showAddLinkModalType}
        />
      </React.Fragment>
    )
  }
}
